import { connect } from 'react-redux';

import {
  getOfficesShortList,
  getPublicZoneList,
} from '../../Offices/officesActions';
import MasterTasks from './MasterTasks';
import {
  addMasterTask,
  editMasterTask,
  getMasterTasks,
} from './masterTasksActions';

const mapStateToProps = state => ({
  masterTasksList: state.task.masterTasksList,
  isLoading: state.task.masterTasksLoading,
  totalTasksCount: state.task.masterTasksCount,
  pageSize: state.task.masterTasksPageSize,
  publicZoneList: state.office.publicZoneList,
  officesShortList: state.office.officesShortList,
  officesShortList2: state.office.officesShortList2,
  addTaskLoading: state.task.addMasterTaskLoading,
});

const mapDispatchToProps = dispatch => ({
  getMasterTasks: params => dispatch(getMasterTasks(params)),
  editMasterTask: params => dispatch(editMasterTask(params)),
  addMasterTask: (params, callback) =>
    dispatch(addMasterTask(params, callback)),
  getPublicZoneList: params => dispatch(getPublicZoneList(params)),
  getOfficesShortList: params => dispatch(getOfficesShortList(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MasterTasks);
